@if (domainResult$ | glxyAsyncStatus | async; as result) {
  <mat-expansion-panel [expanded]="expanded">
    <mat-expansion-panel-header>
      <!-- Icon -->
      @switch (result.status) {
        @case ('loading') {
          <glxy-loading-spinner [size]="'small'" [fullWidth]="false"></glxy-loading-spinner>
        }
        @case ('error') {
          <mat-icon>warning</mat-icon>
        }
        @default {
          <email-domain-status-icon [result]="getStatusIconResult(result)"></email-domain-status-icon>
        }
      }
      <!-- Text -->
      <span>{{ domain.sendFromDomain }}</span>
      @if (domain.isPrimary) {
        <span>({{ 'DOMAIN_AUTHORIZATION.DOMAIN_INFO_CARD.ACTIVE' | translate }})</span>
      }
    </mat-expansion-panel-header>
    <div class="domain-info">
      <!-- Status banner -->
      @switch (result.status) {
        @case ('error') {
          <glxy-alert type="warning" [showAction]="true" [actionTitle]="'Try Again'" (actionClick)="runValidation()">
            {{ 'DOMAIN_AUTHORIZATION.DOMAIN_INFO_CARD.STATUS_BANNER.ERROR' | translate }}
          </glxy-alert>
        }
        @case ('loading') {
          <!-- Nothing -->
        }
        @default {
          @if (!hasAllRecordsMatch(result)) {
            <ng-container [ngTemplateOutlet]="errorNotice"></ng-container>
          }
        }
      }
      <h3>{{ 'DOMAIN_AUTHORIZATION.DOMAIN_INFO_CARD.DNS_RECORDS.HEADER' | translate }}</h3>
      <p>{{ 'DOMAIN_AUTHORIZATION.DOMAIN_INFO_CARD.DNS_RECORDS.SUBTEXT' | translate }}</p>
      <h4>{{ 'DOMAIN_AUTHORIZATION.DOMAIN_INFO_CARD.DMARC_RECORDS.HEADER' | translate }}</h4>
      <email-domain-records-table
        [expectedRecords]="[targetDmarc]"
        [mismatchedRecords]="getMismatches(result)"
        [showMismatches]="true"
      ></email-domain-records-table>
      @if (targetA) {
        <h4>{{ 'DOMAIN_AUTHORIZATION.DOMAIN_INFO_CARD.A_RECORDS.HEADER' | translate }}</h4>
        <email-domain-records-table
          [expectedRecords]="[targetA]"
          [mismatchedRecords]="getMismatches(result)"
          [showMismatches]="true"
        ></email-domain-records-table>
      }
      @if (targetCNAME) {
        <h4>{{ 'DOMAIN_AUTHORIZATION.DOMAIN_INFO_CARD.CNAME_RECORDS.HEADER' | translate }}</h4>
        <email-domain-records-table
          [expectedRecords]="[targetCNAME]"
          [mismatchedRecords]="getMismatches(result)"
          [showMismatches]="true"
        ></email-domain-records-table>
      }
      <h4>{{ 'DOMAIN_AUTHORIZATION.DOMAIN_INFO_CARD.SPF_RECORDS.HEADER' | translate }}</h4>
      <email-domain-records-table
        [expectedRecords]="[targetSpf]"
        [mismatchedRecords]="getMismatches(result)"
        [showMismatches]="true"
      ></email-domain-records-table>
      <h4>{{ 'DOMAIN_AUTHORIZATION.DOMAIN_INFO_CARD.DKIM_RECORDS.HEADER' | translate }}</h4>
      <email-domain-records-table
        [expectedRecords]="targetDKIMs"
        [mismatchedRecords]="getMismatches(result)"
        [showMismatches]="true"
      ></email-domain-records-table>
    </div>
    <div class="actions-container">
      <div class="actions" [ngClass]="{ shadow: showShadow }">
        @if (result.status === 'loaded' && !getMismatches(result)) {
          <button
            mat-flat-button
            color="primary"
            [disabled]="false"
            (click)="useAsDefaultRequested.emit(this.domain.sendFromDomain)"
            >
            <glxy-button-loading-indicator>
              {{ 'DOMAIN_AUTHORIZATION.DOMAIN_INFO_CARD.USE_AS_DEFAULT_DOMAIN' | translate }}
            </glxy-button-loading-indicator>
          </button>
          <button mat-stroked-button (click)="runValidation()" [disabled]="false">
            <glxy-button-loading-indicator [isLoading]="false">
              {{ 'DOMAIN_AUTHORIZATION.DOMAIN_INFO_CARD.ACTIONS.CHECK_RECORDS' | translate }}
            </glxy-button-loading-indicator>
          </button>
        }
        @if (result?.status === 'loading' || !!getMismatches(result)) {
          <button mat-flat-button color="primary" (click)="runValidation()" [disabled]="result?.status === 'loading'">
            <glxy-button-loading-indicator [isLoading]="result?.status === 'loading'">
              {{ 'DOMAIN_AUTHORIZATION.DOMAIN_INFO_CARD.ACTIONS.CHECK_RECORDS' | translate }}
            </glxy-button-loading-indicator>
          </button>
        }
        @if (showDeleteButton && !domain.isPrimary) {
          <button mat-stroked-button (click)="deleteRequested.emit(domain.sendFromDomain)">
            <glxy-button-loading-indicator [isLoading]="deleteInProgress">Delete</glxy-button-loading-indicator>
          </button>
        }
      </div>
    </div>
  </mat-expansion-panel>
}

<ng-template #errorNotice>
  <glxy-alert
    type="error"
    class="authError"
    [showAction]="true"
    [actionTitle]="'DOMAIN_AUTHORIZATION.DOMAIN_INFO_CARD.LEARN_MORE' | translate"
    (actionClick)="openHelpArticle()"
    >
    <div>
      <em>{{ 'DOMAIN_AUTHORIZATION.DOMAIN_INFO_CARD.ERROR_NOTICE.HEADER' | translate }}</em>
      - {{ 'DOMAIN_AUTHORIZATION.DOMAIN_INFO_CARD.ERROR_NOTICE.HINT' | translate }}
    </div>
  </glxy-alert>
</ng-template>

<ng-template #genericHelpModal>
  <h2 mat-dialog-title>{{ 'DOMAIN_AUTHORIZATION.DOMAIN_INFO_CARD.GENERIC_HELP_PANEL.TITLE' | translate }}</h2>

  <mat-dialog-content>
    <p>
      {{ 'DOMAIN_AUTHORIZATION.DOMAIN_INFO_CARD.GENERIC_HELP_PANEL.PAR_1' | translate }}
    </p>
    <h4>{{ 'DOMAIN_AUTHORIZATION.DOMAIN_INFO_CARD.GENERIC_HELP_PANEL.HEADING_1' | translate }}</h4>
    <p>
      {{ 'DOMAIN_AUTHORIZATION.DOMAIN_INFO_CARD.GENERIC_HELP_PANEL.PAR_2' | translate }}
    </p>
    <ul>
      <li>
        {{ 'DOMAIN_AUTHORIZATION.DOMAIN_INFO_CARD.GENERIC_HELP_PANEL.BULLET_LIST.ITEM_1' | translate }}
      </li>
      <li>
        {{ 'DOMAIN_AUTHORIZATION.DOMAIN_INFO_CARD.GENERIC_HELP_PANEL.BULLET_LIST.ITEM_2' | translate }}
      </li>
    </ul>
    <h4>{{ 'DOMAIN_AUTHORIZATION.DOMAIN_INFO_CARD.GENERIC_HELP_PANEL.HEADING_2' | translate }}</h4>
    <p>
      {{ 'DOMAIN_AUTHORIZATION.DOMAIN_INFO_CARD.GENERIC_HELP_PANEL.PAR_3' | translate }}
    </p>
    <ol>
      <li>
        {{ 'DOMAIN_AUTHORIZATION.DOMAIN_INFO_CARD.GENERIC_HELP_PANEL.NUMBERED_LIST.ITEM_1' | translate }}
      </li>
      <li>
        {{ 'DOMAIN_AUTHORIZATION.DOMAIN_INFO_CARD.GENERIC_HELP_PANEL.NUMBERED_LIST.ITEM_2' | translate }}
      </li>

      <li>
        {{ 'DOMAIN_AUTHORIZATION.DOMAIN_INFO_CARD.GENERIC_HELP_PANEL.NUMBERED_LIST.ITEM_3' | translate }}
      </li>
      <li>
        {{ 'DOMAIN_AUTHORIZATION.DOMAIN_INFO_CARD.GENERIC_HELP_PANEL.NUMBERED_LIST.ITEM_4' | translate }}
      </li>
      <li>
        {{ 'DOMAIN_AUTHORIZATION.DOMAIN_INFO_CARD.GENERIC_HELP_PANEL.NUMBERED_LIST.ITEM_5' | translate }}
      </li>
    </ol>
    <h4>{{ 'DOMAIN_AUTHORIZATION.DOMAIN_INFO_CARD.GENERIC_HELP_PANEL.HEADING_1' | translate }}</h4>
    <ul>
      <li>
        {{ 'DOMAIN_AUTHORIZATION.DOMAIN_INFO_CARD.GENERIC_HELP_PANEL.BULLET_LIST.ITEM_3' | translate }}
      </li>
      <li>
        {{ 'DOMAIN_AUTHORIZATION.DOMAIN_INFO_CARD.GENERIC_HELP_PANEL.BULLET_LIST.ITEM_4' | translate }}
      </li>
      <li>
        {{ 'DOMAIN_AUTHORIZATION.DOMAIN_INFO_CARD.GENERIC_HELP_PANEL.BULLET_LIST.ITEM_5' | translate }}
      </li>
    </ul>
    <p>
      {{ 'DOMAIN_AUTHORIZATION.DOMAIN_INFO_CARD.GENERIC_HELP_PANEL.PAR_4' | translate }}
    </p>
  </mat-dialog-content>
  <mat-dialog-actions>
    <button mat-stroked-button color="secondary" matDialogClose>
      {{ 'DOMAIN_AUTHORIZATION.DOMAIN_INFO_CARD.GENERIC_HELP_PANEL.CLOSE' | translate }}
    </button>
  </mat-dialog-actions>
</ng-template>
